<div class="tl-wrap">

  <!-- KPI strip -->
  <div class="tl-kpis" *ngIf="kpi">
    <div class="tl-card tl-kpi">
      <span class="tl-label">Grup Aktif</span>
      <span class="tl-num">{{formatNumber(kpi.groups_live)}}</span>
      <span class="tl-kpi-foot">{{formatNumber(kpi.groups_active_7d)}} ada aktivitas 7 hari &middot; {{formatNumber(kpi.groups_idle)}} senyap<ng-container *ngIf="kpi.groups_deleted"> &middot; {{formatNumber(kpi.groups_deleted)}} dihapus</ng-container></span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Anggota Aktif</span>
      <span class="tl-num">{{formatNumber(kpi.members_active)}}</span>
      <span class="tl-kpi-foot">{{formatNumber(kpi.pending_invites)}} undangan &middot; {{formatNumber(kpi.pending_requests)}} minta bergabung</span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Tuntas Giliran Berjalan</span>
      <span class="tl-num" *ngIf="kpi.today_total">{{formatNumber(kpi.today_done)}}<span class="tl-num-of">/{{formatNumber(kpi.today_total)}}</span></span>
      <span class="tl-num tl-num-sm" *ngIf="!kpi.today_total">Belum ada</span>
      <span class="tl-kpi-foot">
        <span class="tl-bar" *ngIf="kpi.today_total"><span class="tl-bar-fill" [style.width.%]="todayPct()"></span></span>
        <span *ngIf="kpi.today_total">{{todayPct()}}% bagian bacaan selesai</span>
        <span *ngIf="!kpi.today_total">tidak ada giliran bacaan yang berjalan</span>
      </span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Tugas Bacaan &amp; Khatam</span>
      <span class="tl-num">{{formatNumber(kpi.tasks_7d)}}<span class="tl-num-of"> tugas</span></span>
      <span class="tl-kpi-foot">dibuat 7 hari terakhir &middot; <b>{{formatNumber(kpi.khatam_total)}}</b> khatam tercapai</span>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="vl-toolbar">
        <div class="tl-seg" role="tablist" aria-label="Tampilan">
          <button type="button" role="tab" [class.on]="isView == 'groups'" (click)="setView('groups')">Grup</button>
          <button type="button" role="tab" [class.on]="isView == 'activity'" (click)="setView('activity')">Aktivitas</button>
        </div>

        <ng-container *ngIf="isView == 'groups'">
          <input class="vl-input" type="search" placeholder="Cari nama grup, deskripsi, atau pemilik&hellip;"
                 aria-label="Cari grup tilawah" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="active">Aktif</option>
            <option value="idle">Senyap</option>
            <option value="deleted">Dihapus</option>
          </select>
          <select class="vl-select" aria-label="Urutkan"
                  (change)="isSort = $event.target.value; applyFilter()">
            <option value="newest">Terbaru</option>
            <option value="activity">Aktivitas terakhir</option>
            <option value="members">Anggota terbanyak</option>
          </select>
        </ng-container>

        <ng-container *ngIf="isView == 'activity'">
          <input class="vl-input" type="search" placeholder="Cari teks, grup, atau nama&hellip;"
                 aria-label="Cari aktivitas" [value]="actKeyword"
                 (input)="onActKeywordInput($event.target.value)" (keyup.enter)="applyActFilter()">
          <select class="vl-select" aria-label="Filter jenis aktivitas"
                  (change)="actKind = $event.target.value; applyActFilter()">
            <option value="">Semua jenis</option>
            <option *ngFor="let k of kinds()" [value]="k">{{kindMeta(k).label}}</option>
          </select>
          <select class="vl-select" aria-label="Rentang waktu" [value]="actDays"
                  (change)="actDays = $event.target.value; applyActFilter()">
            <option value="7">7 hari terakhir</option>
            <option value="30">30 hari terakhir</option>
            <option value="90">90 hari terakhir</option>
            <option value="">Semua waktu</option>
          </select>
        </ng-container>
        <div class="vl-spacer"></div>
        <span class="tl-readonly" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
      </div>

      <!-- ===== GROUPS ===== -->
      <div class="vl-card" *ngIf="isView == 'groups'">
        <div class="vl-loading" *ngIf="isTableLoading">
          <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
        </div>
        <div class="vl-scroll">
        <table class="vl-table">
          <thead>
          <tr>
            <th class="vl-num">No</th>
            <th>Grup</th>
            <th>Pemilik</th>
            <th class="text-center">Anggota</th>
            <th>Target</th>
            <th>Progres</th>
            <th>Aktivitas Terakhir</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let v of isData; let i = index" class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1"
              [class.tl-deleted]="v.status == 'deleted'" (click)="openDetail(v)">
            <th class="vl-num">{{rowNo(i)}}</th>
            <td>
              <div class="tl-ident">
                <img *ngIf="v.photoUrl" [src]="v.photoUrl" alt="{{v.name}}" class="tl-thumb"
                     onerror="this.onerror=null;this.style.display='none';">
                <span *ngIf="!v.photoUrl" class="tl-thumb tl-thumb-ph"><i class="fa fa-book-open"></i></span>
                <div class="tl-ident-text">
                  <span class="vl-name" [innerHTML]="highlight(v.name)"></span>
                  <span class="tl-desc" *ngIf="v.description" [innerHTML]="highlight(v.description)" [title]="v.description"></span>
                  <span class="tl-desc vl-muted" *ngIf="!v.description">Dibuat {{v.createdVw}}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="tl-owner">
                <img *ngIf="v.ownerPhotoUrl" [src]="v.ownerPhotoUrl" alt="" class="tl-avatar"
                     onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                <img *ngIf="!v.ownerPhotoUrl" src="assets/images/no_avatar.webp" alt="" class="tl-avatar">
                <span [innerHTML]="highlight(v.ownerName)"></span>
              </div>
            </td>
            <td class="text-center">
              <span class="tl-count">{{formatNumber(v.member_count)}}</span>
              <div class="vl-muted vl-small" *ngIf="v.pending_count">+{{formatNumber(v.pending_count)}} menunggu</div>
            </td>
            <td>
              <span>{{v.targetVw}}</span>
              <div class="vl-muted vl-small">{{v.scopeVw}} &middot; {{v.recordVw}}</div>
              <div class="vl-muted vl-small">mulai {{v.start_surah_name}}</div>
            </td>
            <td>
              <ng-container *ngIf="v.current_days">
                <div class="tl-prog">
                  <span class="tl-chip">Khatam ke-{{v.current_cycle}}</span>
                  <span>{{v.turnVw}}</span>
                  <span class="vl-muted">&middot;</span>
                  <span>Juz {{v.current_juz}}</span>
                </div>
                <div class="tl-today" *ngIf="v.today_total">
                  <span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="v.todayPct"></span></span>
                  <span class="vl-muted vl-small">{{v.currentTurnVw}} {{v.today_done}}/{{v.today_total}}</span>
                </div>
                <div class="vl-muted vl-small" *ngIf="!v.today_total">tidak ada bagian {{v.currentTurnVw}}</div>
              </ng-container>
              <span class="vl-muted" *ngIf="!v.current_days">Belum mulai<ng-container *ngIf="v.current_cycle > 1"> &middot; Khatam ke-{{v.current_cycle}}</ng-container></span>
            </td>
            <td>
              <span [title]="v.lastActivityFull">{{v.lastActivityVw}}</span>
            </td>
            <td>
              <span class="vl-pill" [class.on]="v.status == 'active'" [class.off]="v.status == 'idle'" [class.del]="v.status == 'deleted'">
                <span class="vl-dot"></span>{{statusLabel(v.status)}}</span>
            </td>
          </tr>
          <tr *ngIf="!isData.length && !isTableLoading">
            <td colspan="8" class="vl-empty">Tidak ada grup yang cocok</td>
          </tr>
          </tbody>
        </table>
        </div>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> grup</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi halaman">
            <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of isPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage" (click)="goToPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

      <!-- ===== ACTIVITY FEED ===== -->
      <div class="vl-card" *ngIf="isView == 'activity'">
        <div class="vl-loading" *ngIf="actLoading">
          <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
        </div>
        <ul class="tl-feed">
          <li *ngFor="let a of actData" class="tl-feed-row">
            <span class="tl-feed-ico" [ngClass]="a.meta.tone"><i class="fa" [ngClass]="a.meta.icon"></i></span>
            <div class="tl-feed-body">
              <div class="tl-feed-text" [innerHTML]="highlight(a.textVw, actKeyword)"></div>
              <div class="tl-feed-meta">
                <a [routerLink]="['/tilawah', a.tilawah_id]" class="tl-feed-group" [innerHTML]="highlight(a.tilawah_name || 'Grup #' + a.tilawah_id, actKeyword)"></a>
                <span class="vl-tag kind">{{a.meta.label}}</span>
                <span class="vl-muted" *ngIf="a.tilawah_deleted_at">grup sudah dihapus</span>
              </div>
            </div>
            <time class="tl-feed-time" [title]="a.timeFull">{{a.timeVw}}</time>
          </li>
          <li *ngIf="!actData.length && !actLoading" class="vl-empty">Tidak ada aktivitas pada rentang ini</li>
        </ul>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(actFrom())}}&ndash;{{formatNumber(actTo())}}</b> dari <b>{{formatNumber(actTotal)}}</b> aktivitas</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi halaman aktivitas">
            <button type="button" class="vl-page" [disabled]="actPage == 1" (click)="goToActPage(actPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of actPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == actPage" (click)="goToActPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="actPage == actTotalPages()" (click)="goToActPage(actPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

    </div>
  </div>
</div>
